
// fill in both in order to get proper intellisense
export type BaseDict = {
    ViewAllButton: string
    LiveIndicator: string,
    FirstOvertime: string,
    BreakAfterFirstOvertime: string,
    SecondOvertime: string,
    FirstSet: string,
    SecondSet: string,
    ThirdSet: string,
    FourthSet: string,
    FifthSet: string
    FirstPeriod: string,
    BreakAfterFirstPeriod: string,
    SecondPeriod: string,
    BreakAfterSecondPeriod: string,
    ThirdPeriod: string,
    BreakAfterThirdPeriod: string,
    FirstQuarter: string,
    BreakAfterFirstQuarter: string,
    SecondQuarter: string,
    BreakAfterSecondQuarter: string,
    ThirdQuarter: string,
    BreakAfterThirdQuarter: string,
    FourthQuarter: string,
    BreakAfterFourthQuarter: string,
    Overtime: string,
    FirstHalf: string,
    SecondHalf: string,
    BreakAfterFirstHalf: string,
    StartsIn: string
};
export const BaseDict: BaseDict = {
    ViewAllButton: "View All",
    LiveIndicator: "LIVE",
    FirstOvertime: "FirstOvertime",
    BreakAfterFirstOvertime: "BreakAfterFirstOvertime",
    SecondOvertime: "SecondOvertime",
    FirstSet: "FirstSet",
    SecondSet: "SecondSet",
    ThirdSet: "ThirdSet",
    FourthSet: "FourthSet",
    FifthSet: "FifthSet",
    FirstPeriod: "FirstPeriod",
    BreakAfterFirstPeriod: "BreakAfterFirstPeriod",
    SecondPeriod: "SecondPeriod",
    BreakAfterSecondPeriod: "BreakAfterSecondPeriod",
    ThirdPeriod: "ThirdPeriod",
    BreakAfterThirdPeriod: "BreakAfterThirdPeriod",
    FirstQuarter: "FirstQuarter",
    BreakAfterFirstQuarter: "BreakAfterFirstQuarter",
    SecondQuarter: "SecondQuarter",
    BreakAfterSecondQuarter: "BreakAfterSecondQuarter",
    ThirdQuarter: "ThirdQuarter",
    BreakAfterThirdQuarter: "BreakAfterThirdQuarter",
    FourthQuarter: "FourthQuarter",
    BreakAfterFourthQuarter: "BreakAfterFourthQuarter",
    Overtime: "Overtime",
    FirstHalf: "FirstHalf",
    SecondHalf: "SecondHalf",
    BreakAfterFirstHalf: "BreakAfterFirstHalf",
    StartsIn: "Starts in:"
};